import axios from 'axios';
import cookie from 'react-cookie';
import { Toastr } from 'modules/toastr';
import {browserHistory} from 'react-router';
let errorCatcher = false;
var Promise = require('es6-promise').Promise;
export default function customFetch(url, options) {
  // return a promise of axios
  let at = cookie.load('accessToken');
  if (at) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${at}`;
    errorCatcher = false;
  }

  return new Promise((resolve, reject) => {
    axios(url, options).then(response => {
      resolve(response);
    }).catch(error => {
      if (error.response && error.response.status == 401 && errorCatcher == false) {
        errorCatcher = true;
        cookie.remove('accessToken', {path: '/'});
        localStorage.removeItem('userInfo');
        localStorage.removeItem('thamSo');
        // if (error.response.data && error.response.data.errors.length && error.response.data.errors[0].redirectUrl) {
        //   window.location.replace(error.response.data.errors[0].redirectUrl);
        // } else {
          browserHistory.push('/dang-nhap');
        // }
        Toastr(error.response.data.errors[0].detail, 'error');
      }
      reject(error);
    });
  });
}



// WEBPACK FOOTER //
// ./src/api/axios.js